import superagent from 'superagent';

export class OoyalaApiClient {
  constructor(client) {
    this.client = client;
  }

  getAsset(id) {
    return Promise.resolve();
  }

  getClosestMatchingPreviewImage(width, height, assetData){
    if (!assetData){
      return null;
    }

    // 1. Group by aspect ratio (to 1 decimal place)
    const ratioFn = (w, h) => Number((w / h).toFixed(1));
    const diffFn = (a, b) => Math.abs(a - b);
    const requiredRatio = ratioFn(width, height);

    const assetsByRatio = assetData.reduce((grouping, asset) => {
      const ratio = ratioFn(asset.width, asset.height);
      const out = {[ratio]: [], ...grouping};                 // default ratio group to an empty array.
      out[ratio].push(asset);                                 // add the asset to the ratio group
      return out;
    }, {});

    // 2. find closest aspect ratio group
    const closestByRatio = Object.keys(assetsByRatio)
          .map(ratio => [diffFn(requiredRatio, ratio), assetsByRatio[ratio]]) // Decorate with difference
          .sort((a, b) => a[0] - b[0])                                        // Sort by difference
          .map(pair => pair[1])[0];                                           // Undecorate

    // 3. Sort group by closest to width.
    const closestByWidth = closestByRatio
      .map(asset => [diffFn(width, asset.width), asset])   // Decorate with difference
      .sort((a, b) => a[0] - b[0])                         // Sort by difference
      .map(pair => pair[1])[0];                            // Undecorate

    return closestByWidth;
  }
}

const instance = new OoyalaApiClient(superagent)

export default instance;



// WEBPACK FOOTER //
// ./modules/Ooyala/client/OoyalaApiClient.js